import ApiClient from "~/admin/services/ApiClient";

export default class StatsApi {
  static get = () => ApiClient.get("stats");
}
